module.exports = __webpack_public_path__ + "static/media/user.7d39d3eb.svg";